export default __webpack_public_path__ + "resources/icons/logo-4479.svg";